(() => {
  const header = document.querySelector('.section-header');
  if (header) {
    const updateHeader = () => header.classList.toggle('is-luxury-scrolled', window.scrollY > 12);
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });
  }

  document.querySelectorAll('.luxury-hero').forEach((hero) => {
    const syncActiveSlide = () => {
      const slides = hero.querySelectorAll('.slideshow__slide');
      let active = hero.querySelector('.slideshow__slide[aria-hidden="false"]') || slides[0];
      slides.forEach((slide) => slide.classList.toggle('is-active', slide === active));
    };
    syncActiveSlide();
    new MutationObserver(syncActiveSlide).observe(hero, { subtree: true, attributes: true, attributeFilter: ['aria-hidden'] });
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.luxury-wishlist');
    if (!button) return;
    const pressed = button.getAttribute('aria-pressed') === 'true';
    button.setAttribute('aria-pressed', String(!pressed));
  });
})();
